module.exports = __webpack_public_path__ + "img/hjzy.4c375799.png";